var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_validate-collection.js
// module id = ./node_modules/core-js/modules/_validate-collection.js
// module chunks = 54 55